module.exports = __webpack_public_path__ + "img/w23-cover.8e9bcdab.jpg";